// extracted by mini-css-extract-plugin
export var bottom = "Shadow-module--bottom--843ca";
export var left = "Shadow-module--left--2097b";
export var right = "Shadow-module--right--1dac4";
export var shadow = "Shadow-module--shadow--8b5bd";
export var top = "Shadow-module--top--fa76e";